<template>

 <v-container fluid>

  </v-container>
  
</template>

<script>

import { postCsvFile, getAllDataAsCsv } from '../utils/effort-tracking-api';
import { getImportProgress, getExportProgress, getCsvFile} from '../utils/effort-tracking-api';
import axios from 'axios'

export default {
    data() {
        return {
          uploadFieldName: '',
          fileName: '',
          file: [],
          options: [],
          selectedOption: null,
          uploadbar: false,
          uploadProgress: false,
          uploadResults: false,
          show: true,
          loading: false,
          teachersProcessed: 0,
          studentsProcessed: 0,
          classesProcessed: 0,
          errors: 0,
          errorItems: [],
          defaultSelected: true,
          timer: '',
          timerExport: '',
          progressReport: '',
          progressRetries: 0,
          maxProgressRetries: 3,
          exportResults: false,
          loadingExport: false,
          showExport: false,
          exportedFile: '',
          showFile: false,
          linkToFile: ''
        }
    },
    methods: {
        filesChange(name, file){
            this.file = file;
        },
        downloadFile(){
            var url = getCsvFile();
            console.log(url);
            this.exportedFile = url;
        },
        exportCsv() {
            this.loadingExport = true;
            this.exportResults = true;
            this.showExport = true;
            //var periodId = 1;
            var periodId = localStorage.getItem('period-selected');

            getAllDataAsCsv(periodId).then(result => {
                console.log(result);
                this.progressRetries = 0
                if(result){
                    this.timerExport = setInterval(this.exportProgressUpdate, 10000);
                }
            });
        },
        exportProgressUpdate(){
            getExportProgress().then(progress => {
                console.log(progress.status.isDone);
                if(progress.status.isDone)
                {
                    console.log(progress.exportedFile);
                    this.showFile = true;
                    // this.linkToFile = 'getfile/' + progress.exportedFile;
                    this.exportedFile = progress.exportedFile;
                    this.loadingExport = false;
                    this.downloadFile();
                }

                if(!progress.isRunning){
                    this.progressRetries++;
                    if(this.progressRetries > this.maxProgressRetries){
                        clearInterval(this.timerExport);
                    }
                }
            });
            // if(!progress.isRunning){
            //         this.progressRetries++;
            //     if(this.progressRetries > this.maxProgressRetries){
            //         clearInterval(this.timerExport);
            //         console.log('Retrying...');
            //     }
            // }
        },
        importCsv() {
            this.uploadbar = false;
            this.uploadProgress = true;
            this.show = true
            this.loading = true
            this.uploadResults = false;
            this.errorItems = []
            this.errors = 0
            this.teachersProcessed = 0
            this.studentsProcessed = 0
            this.classesProcessed = 0
            
            var option = this.selectedOption;
   
            postCsvFile(this.file, option).then(result => {
                this.progress = 100;
                this.loading = false;
                this.progressRetries = 0
                if (result.status == 200) {
                    this.loading = true;
                    this.timer = setInterval(this.progressUpdate, 2000);
                } else {
                    
                }
            }).catch(ex => {
                console.log(ex)
                var message = ex.message
                if(ex.response){
                    message = ex.response.data === undefined ? ex : ex.response.data;
                }
                this.progress = 100;
                this.loading = false;
                this.errors = 1;
                this.errorItems.push( { "id": "0", "value": message })    
                this.uploadProgress = false;
                this.uploadResults = true;
            });
        },
        progressUpdate() {
            getImportProgress().then(progress => {
                this.progressReport = progress.report;
                
                if(!progress.isRunning){
                    this.progressRetries++;
                    if(this.progressRetries > this.maxProgressRetries){
                        clearInterval(this.timer);
                        this.showResults(progress.status)
                    }
                }
            }).catch(ex => {
                clearInterval(this.timer);
                var message = ex.message
                console.log(ex)
                if(ex.response){
                    message = ex.response.data === undefined ? ex : ex.response.data;
                }
                    
                
                this.progress = 100;
                this.loading = false;
                this.errors = 1;
                this.errorItems.push( { "id": "0", "value": message })    
                this.uploadProgress = false;
                this.uploadResults = true;
            })
        },
        showResults(results) {            
            this.uploadProgress = false;
            this.uploadResults = true;

            this.teachersProcessed = results.processedTeachers;
            this.studentsProcessed = results.processedStudents;
            this.classesProcessed = results.processedClasses;
            this.errors = results.ErrorsFound;

            results.errors.forEach( element => {
                this.errorItems.push( { "id": "0", "value": element } );    
            });

        }
    },

    mounted() {

        this.uploadbar = false;
        this.uploadProgress = false;
        this.uploadResults = false;
        this.options.push(
            //{ id: 0, text: 'Add new records only (this will insert new data without affecting existing records)' },
            //{ id: 1, text: 'Merge with existing data (this will insert new data and update existing records)' },
            { id: 2, text: 'Replace existing data (this will wipe out all existing information, including Effort Grades and Student and Teacher Logins)' }
        );
        this.selectedOption = 2;
    },
    beforeDestroy() {
        clearInterval(this.timer);
        clearInterval(this.timerExport);
    }
}
</script>



// WEBPACK FOOTER //
// src/components/DataManagement.vue